module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-left-1ae78e09.svg";